export const NOTIFICATION_CONTAINER_SELECTOR = '.js-globalNotifications';

export enum NotificationType {
  Confirmation = 'info',
  Info = 'warning',
  Error = 'danger'
}

export default class Notification {

  private readonly el: JQuery;

  constructor(
    public message: string,
    public type: NotificationType = NotificationType.Confirmation,
  ) {
    this.el = $(
      `<div class="alert alert-${this.type} alert-dismissable js-notification">
        <button class="close js-closeNotification" aria-hidden="true" data-dismiss="alert" type="button">&times;</button>
        ${this.message}
      </div>`,
    );
    this.el.data('input-class', this);
    this.bindCloseButton();
  }

  static getInstance(element: JQuery | HTMLElement): Notification {
    if (element instanceof HTMLElement) {
      element = $(element); // eslint-disable-line no-param-reassign
    }
    return element.data('input-class') as Notification;
  }

  getElement(): JQuery {
    return this.el;
  }

  show(): void {
    $(NOTIFICATION_CONTAINER_SELECTOR).append(this.el);
    this.el.slideUp(0);
    this.el.slideDown(200);
  }

  close(): void {
    this.el.slideUp(100, () => this.el.remove());
  }

  private bindCloseButton(): void {
    this.el.find('.js-closeNotification').on('click', () => this.close());
  }
}
